(() => {
  'use strict';
  const init = root => {
    if (root.dataset.mgRelatedReady) return;
    root.dataset.mgRelatedReady = 'true';
    const items = [...root.querySelectorAll('[data-mg-related-item]')];
    const more = root.querySelector('[data-mg-related-more]');
    const status = root.querySelector('[data-mg-related-status]');
    const key = `moregosu.relatedGuides.v1:${location.pathname}:${root.dataset.articleId}`;
    const mobile = window.matchMedia('(max-width: 749px)');
    let count = Math.min(3, items.length);
    const read = () => {
      try {
        const value = JSON.parse(sessionStorage.getItem(key));
        if (!value || !Number.isFinite(value.count) || !Number.isFinite(value.y)) return null;
        return {count: Math.min(items.length, Math.max(3, Math.floor(value.count))), y: Math.max(0, value.y), pending: value.pending === true};
      } catch { return null; }
    };
    const save = pending => {
      try { sessionStorage.setItem(key, JSON.stringify({count, y:window.scrollY, pending})); } catch {}
    };
    const render = () => {
      items.forEach((item, i) => { item.hidden = i >= count; });
      more.hidden = count >= items.length;
    };
    const previous = read();
    if (previous) count = previous.count;
    render();
    more.addEventListener('click', () => {
      const firstNew = items[count];
      count = Math.min(count + 3, items.length);
      render();
      firstNew?.querySelector('a[href]')?.focus({preventScroll:true});
      status.textContent = more.hidden ? status.dataset.complete : '';
      save(false);
    });
    root.addEventListener('click', event => {
      const anchor = event.target.closest('a[href]');
      if (!anchor || !mobile.matches || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || anchor.target === '_blank') return;
      if (anchor.origin === location.origin) save(true);
    });
    const restore = event => {
      const record = read();
      const back = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
      if (!record || !record.pending || !mobile.matches || (!event.persisted && !back)) return;
      count = record.count;
      render();
      if (!event.persisted) {
        requestAnimationFrame(() => requestAnimationFrame(() => {
          window.scrollTo({top:record.y, behavior:'instant'});
          save(false);
        }));
      } else save(false);
    };
    window.addEventListener('pageshow', restore);
  };
  const start = () => document.querySelectorAll('[data-mg-related-guides]').forEach(init);
  start();
  document.addEventListener('shopify:section:load', start);
})();
